import template from './cannyEnhancementsNz.html';
import CannyEnhancementsNzCtrl from './cannyEnhancementsNzCtrl';

export default {
  template,
  controller: CannyEnhancementsNzCtrl,
  controllerAs: 'vm',
};
